/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Client {
    'use strict';

    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    import ModalTranslationModes = Meevo.Components.Modal.ModalTranslationModes;
    import PresetStatus = Meevo.Components.Controls.PresetStatus;
    import ClientIntakeFormService = Meevo.Plugins.ClientIntakeForm.ClientIntakeFormService;
    import SecurityEntityTypeEnum = Meevo.Model.SecurityEntityTypeEnum;

    export class ClientContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        private mainSection: MainSection;
        private historySection;
        private notificationsSection;
        public missingField: any = -1;
        public isPhoneNumberAccessDeny: boolean = false;
        public isFileUploadAccessDeny: boolean = false;
        private imageGalleryService: any;
        public employeeLinkDetails: any = null;
        public newPhoneNumber: any = null;
        private bithdayLabel: string;
        private firstDelimiter: string;
        private secondDelimiter: string
        private dtMonthIndex: number;
        private dtDayIndex: number;
        private dtYearIndex: number;
        public enablePurge: boolean;
        public presetStatus: PresetStatus;
        public selectedPreset: any;
        public currentLocationId: number;
        notificationSetting: Model.NotificationSetting;
        // TODO: Move this to base class if/when other maintenance contexts start needing the recent service
        protected recentService: Meevo.Components.Common.RecentService;
        protected apptConfirmationSendDaysBeforeList: any;
        protected apptReminderSendDaysBeforeList: any;
        public isClientNoteShared: boolean;
        public disableEditingOfRestrictedClient: boolean;
        public displayPopupNotesAcrossLocations: boolean;
        public lockRestrictedClient: boolean;
        public hasToUnrestrictAtSameRestrictLocation: boolean;
        public isClientRestricted: boolean;
        public isClientLockedForEditing: boolean;
        public showUnlockButton: boolean;
        public showUnrestrictButton: boolean;
        public isTextelOrTwoWaySmsEnabled: boolean = false;
        registerSettings: Meevo.Plugins.BusinessInfo.IBusinessInfoRegisterSettings;
        public twilioPhoneNumber: string;
        public unstopSmsLabel: string;
        public isTollFreeNumberSupported: boolean;
        public useNewVisitNotes: boolean;
        public meevoMessengerSecurityKey: string;

        public isExpanded: boolean = true;

        private _intakeFormWatcher: () => void;

        private scope: any;
        get clientHistoryType() {
            return ClientHistoryType;
        }

        get showEdit() {
            return this.selectedSection instanceof DocsAndFormsSection ? false : this.showEditLogic();
        }

        get customTabId(): number {
            return 99;
        }

        get customSecurityEntity(): number {
            return SecurityEntityTypeEnum.UdfClient;
        }

        get customTabSecurityKey(): string {
            return this.securityKeys.DATA_CLIENT_TAB_CUSTOMUDFTABS;
        }

        get clientAppointmentHistoryFilterType() {
            return ClientAppointmentHistoryFilterType;
        }

        get auditNoun(): Meevo.Model.NounEnum | null {
            if (this.selectedSection) {
                const noun = this.selectedSection["auditNoun"];
                if (_.isUndefined(noun) === false && noun !== null) {
                    return noun;
                }
            }
            return null;
        }

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
                    protected dataService: Meevo.Components.BaseClasses.IDataService,
                    modalService: Meevo.Components.Modal.IModalService,
                    identityService: Meevo.Components.Common.IIdentityService,
                    loggingService: Meevo.Components.Logging.ILoggingService,
                    public securityService: Meevo.Components.Common.ISecurityService,
                    protected hostedPageService: Meevo.Components.HostedPage.IHostedPageService,
                    protected addressFieldsService: Meevo.Components.Common.IAddressFieldsService,
                    trackingService: Meevo.Components.Tracking.ITrackingService,
                    recentService: Meevo.Components.Common.RecentService,
                    customDataContextConfig: Meevo.Model.ICustomDataContextConfig,
                    protected contextParams: IContextParams,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    public $q: angular.IQService,
                    protected $scope: angular.IScope,
                    protected $translate: angular.translate.ITranslateService,
                    protected $rootScope: angular.IRootScopeService,
                    protected $cookies: angular.cookies.ICookiesService,
                    protected printService: Meevo.Components.Common.IPrintService,
                    protected recentClientsService: Meevo.Plugins.Client.RecentClientsService,
                    imageGalleryService: Meevo.Components.Common.IImageGalleryService,
                    protected _employeeLinkDetails: any,
                    protected _newPhoneNumber: any,
                    public isNotificationEnabled: boolean,
                    protected $sce,
                    protected businessInfoDataService: Meevo.Components.Common.IBusinessInfoDataService,
                    protected docsAndFormsService: Meevo.Plugins.DocsAndForms.DocsAndFormsService,
                    protected $locale: angular.ILocaleService,
                    protected clientIntakeFormService: ClientIntakeFormService,
                    protected sideContextMenu: Meevo.IMeevoSideMenu,
                    protected $filter: angular.IFilterService) {

            super(
                appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityService,
                trackingService,
                customDataContextConfig,
                false
            );
            this.baseEndpoint = appSettings.API_ENDPOINTS.client;
            this.sectionTemplatePath = 'app/plugins/client/sectionViews/';
            this.recentService = recentService;
            this.imageGalleryService = imageGalleryService;

            this.useNewVisitNotes = $rootScope['clientsSettings'].useNewVisitNotes;

            this.employeeLinkDetails = _employeeLinkDetails;
            this.newPhoneNumber = _newPhoneNumber;
            this.currentLocationId = this.identityService.locationId;
            this.initializeSections();
            if (this.customDataContextConfig && this.customDataContextConfig.appAreaTabs.length > 0) {
                this.renderCustomSections();
            }

            this._intakeFormWatcher = this.$rootScope.$on(Meevo.Components.Common.Messages.CLOSE_INTAKE_FORM, () => {
                if (this.itemId) {
                    this.reloadSelectedSection();
                }
            });

            this.bithdayLabel = this.$translate.instant('LABEL_BIRTHDAY', { dateFormat: this.createDateFormat() });
            this.scope = $scope;
            this.registerSettings = this.scope.$root['registerSettings'];

            this.dataService.customMethodData('api/Settings/Clients', 'GET', null)
                .then(response => {
                    this.$rootScope['clientsSettings'] = response.data;

                    this.isClientNoteShared = $rootScope['clientsSettings'].showClientNotesAcrossLocation;
                    this.disableEditingOfRestrictedClient = $rootScope['clientsSettings'].doNotAllowEditingOfRestrictedClients;
                    this.displayPopupNotesAcrossLocations = $rootScope['clientsSettings'].displayPopupNotesAcrossLocations;
                    this.lockRestrictedClient = $rootScope['clientsSettings'].requireRestrictedClientToBeUnlocked;
                    this.hasToUnrestrictAtSameRestrictLocation = $rootScope['clientsSettings'].requireSameLocationToUnrestrict;

                    var purgeSetting = _.find($rootScope['clientsSettings'].settings, setting => setting['displayName'].toUpperCase() === ('EnablePurge').toUpperCase());

                    if (purgeSetting != null && purgeSetting['effectiveValue'] == '1')
                        this.enablePurge = true;
                    else
                        this.enablePurge = false;
                });

            this.isTollFreeNumberSupported = this.identityService.current().systemSettings.isTollFreeNumberSupported;   
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_CLIENT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.mainSection = new MainSection(0,
                    'SECTION_CLIENT_MAIN',
                    'main.html',
                    true,
                    false,
                    this.baseEndpoint,
                    '',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    this.securityService,
                    Meevo.Model.NounEnum.ClientMain,
                    this.appSettings,
                    this.recentClientsService,
                    this.employeeLinkDetails,
                    this.newPhoneNumber,
                    this.modalService,
                    this.securityKeys.DATA_CLIENT_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this,
                    this.businessInfoDataService,
                    this.$rootScope,
                    this.busyService,
                    this.$translate,
                    this.$q);

                this.sections.push(this.mainSection);
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_CLIENT_TAB_NOTIFICATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.notificationsSection = new NotificationsSection(10,
                    'Notifications',
                    'notifications.html',
                    false,
                    false,
                    this.baseEndpoint,
                    'Notifications',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    this.securityService,
                    Meevo.Model.NounEnum.ClientNotificationsTab,
                    this.appSettings,
                    this.modalService,
                    this.securityKeys.DATA_CLIENT_TAB_NOTIFICATIONS + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this,
                    this.$rootScope,
                    this.busyService,
                    this.$translate);
                this.sections.push(this.notificationsSection);
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_CLIENT_TAB_NOTES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new NotesSection(1,
                    'SECTION_CLIENT_NOTES',
                    'notes.html',
                    false,
                    true,
                    '',
                    '/notes',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    this.securityService,
                    Meevo.Model.NounEnum.ClientNotes,
                    null,
                    this.securityKeys.DATA_CLIENT_TAB_NOTES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.$translate,
                    this.modalService));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_CLIENT_TAB_VISITNOTES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                if (this.useNewVisitNotes) {
                    this.sections.push(new NewVisitNotesSection(2,
                        'SECTION_CLIENT_VISIT_NOTES',
                        'newVisitNotes.html', false, true, '', 'visitnotes/list', this.loggingService, this.dataService, this.identityService,
                        Model.NounEnum.ClientVisitNotes, this.contextParams, this.appSettings,
                        this.securityKeys.DATA_CLIENT_TAB_VISITNOTES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        this.translateService));
                }
                else {
                    this.sections.push(new VisitNotesSection(2,
                        'SECTION_CLIENT_VISIT_NOTES',
                        'visitNotes.html',
                        false,
                        true,
                        '',
                        '/visitnotes',
                        this.loggingService,
                        this.dataService,
                        this.identityService,
                        this.securityService,
                        Meevo.Model.NounEnum.ClientVisitNotes,
                        this.$scope,
                        this.$q,
                        this.$sce,
                        this.$translate,
                        null,
                        this.securityKeys.DATA_CLIENT_TAB_VISITNOTES + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        this.modalService));
                }
            }
            if (this.securityChecker.hasSecurity(this.securityKeys.DATA_CLIENT_TAB_HISTORY + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.historySection = new HistorySection(3,
                    'SECTION_HISTORY',
                    'history.html',
                    false,
                    true,
                    this.baseEndpoint,
                    '/history',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.ClientHistory,
                    this.$cookies,
                    this.printService,
                    this.modalService,
                    this.recentClientsService,
                    this.trackingService,
                    this.busyService,
                    this.$q,
                    this.$scope,
                    this.appSettings,
                    this.$rootScope,
                    this,
                    this.$filter,
                    this.$sce,
                    this.securityKeys.DATA_CLIENT_TAB_HISTORY + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.$translate,
                    this.securityChecker);
                this.sections.push(this.historySection);
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_CLIENT_TAB_FAMILY + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                var canBreakFamily = this.identityService.current().fullAccess || this.securityChecker.hasSecurity(this.securityKeys.DATA_CLIENT_TAB_FAMILY + ':BREAK');
                this.sections.push(new FamilySection(4,
                    'SECTION_CLIENT_FAMILY',
                    'family.html',
                    true,
                    false,
                    this.baseEndpoint,
                    'family',
                    this.loggingService,
                    this.dataService,
                    canBreakFamily,
                    this.identityService,
                    this.modalService,
                    this.$translate,
                    Meevo.Model.NounEnum.ClientFamily,
                    this.busyService,
                    this.$q,
                    this.appSettings,
                    this.$rootScope,
                    this.trackingService,
                    this.securityKeys.DATA_CLIENT_TAB_FAMILY + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
            if (this.securityChecker.hasSecurity(this.securityKeys.DATA_CLIENT_TAB_BOOKINGPREFERENCES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new BookingPreferencesSection(5,
                    'SECTION_CLIENT_BOOKING_PREFERENCES',
                    'bookingPreferences.html',
                    false,
                    false,
                    this.baseEndpoint,
                    'bookingPreferences',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.ClientBookingPreferences,
                    this.$translate));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_CLIENT_TAB_CREDITCARDS + Meevo.Components.Common.SecurityParts.KEY_PART_READ) && !this.isApplicationModeCO()) {
                this.sections.push(new CreditCardSection(8,
                    'SECTION_CLIENT_CREDIT_CARD',
                    'creditCard.html',
                    false,
                    true,
                    '',
                    'creditcard',
                    this.loggingService,
                    this.dataService,
                    this.modalService,
                    this.$q,
                    this.$translate,
                    this.identityService,
                    Meevo.Model.NounEnum.ClientCreditCard,
                    this.appSettings,
                    this.securityChecker,
                    this.hostedPageService,
                    this.addressFieldsService,
                    this.securityKeys.DATA_CLIENT_TAB_CREDITCARDS + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_CLIENT_TAB_IMAGEGALLERY + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new ImageGallerySection(9,
                    'SECTION_IMAGE_GALLERY',
                    'imageGallery.html',
                    false,
                    true,
                    '',
                    'imagegallery',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.ClientImageGallery,
                    this.contextParams,
                    this.modalService,
                    this.imageGalleryService,
                    this.securityKeys.DATA_CLIENT_TAB_IMAGEGALLERY + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
            if (this.securityChecker.docsAndFormsClientTabCheck(this.securityKeys.DATA_CLIENT_TAB_DOCSANDFORMS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new NewDocsAndFormsSection(6,
                    'HERO_SUB_DOCS_AND_FORMS',
                    'newDocsAndForms.html', false, true, '', 'docsandforms/list', this.loggingService, this.dataService, this.identityService,
                    Model.NounEnum.ClientDocsAndForms, this.contextParams, this.appSettings,
                    this.securityKeys.DATA_CLIENT_TAB_DOCSANDFORMS + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.translateService));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_CLIENT_TAB_CHARTS + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new ClientChartsSection(7,
                    'SECTION_CLIENT_CHARTS',
                    'charts.html', false, true, '', 'client-charts-list', this.loggingService, this.dataService, this.identityService,
                    Model.NounEnum.ClientCharts, this.appSettings,
                    this.securityKeys.DATA_CLIENT_TAB_CHARTS + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                    this.translateService, this.contextParams));
            }

        }        
        selectSection(item, subSectionContentKey?: string, isClicked: boolean = false): void {
            switch (item.sectionId) {
                case 1: //Notes
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_CLIENT_TAB_NOTES, true);
                    break;
                case 2: //Visit Notes
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_CLIENT_TAB_VISITNOTES);
                    break;
                case 3: //History
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_CLIENT_TAB_MAIN, false, true);
                    this.presetStatus = Components.Controls.PresetStatus.LastTwelveMonthsIncludingToday;
                    this.selectedPreset = _.findWhere(this.historySection.presetList, { status: this.presetStatus });
                    this.editSecurityKey = '';
                    this.initializeMainTab();
                    this.loadNotificationSetting();
                    this.historySection.hideMobileFilters = false;
                    break;
                case 4: //Family
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_CLIENT_TAB_FAMILY);
                    break;
                case 5: //Booking Preferences
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_CLIENT_TAB_BOOKINGPREFERENCES);
                    break;
                case 7: //Charts
                    if (isClicked && this.contextParams.params) { //Charts
                        if (this.contextParams.params["sourceModule"]) {
                            this.contextParams.params["sourceModule"] = Meevo.Model.ModuleEnum.System;
                        }
                        if (this.contextParams.params["mode"]) {
                            this.contextParams.params["mode"] = null;
                        }
                        
                    }
                    break;
                case 8: //Credit Card
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_CLIENT_TAB_CREDITCARDS);
                    break;
                case 10: //Notifications
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_CLIENT_TAB_NOTIFICATIONS);
                    break;
                case 9:     //Image Gallery
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_CLIENT_TAB_IMAGEGALLERY);
                    break;
                case this.customTabId: // custom tabs
                    this.buildCrudSecurityKeysBase(this.customTabSecurityKey);
                    break;
                default: //Main
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_CLIENT_TAB_MAIN, true, true);
                    this.initializeMainTab();
                    break;
            }          
            super.selectSection(item, subSectionContentKey);
        }

        initializeMainTab() {
            if (this.mainSection) {
                this.mainSection.hasTransaction = false;
            }
            this.securityChecker.checkSecurityKey(this.securityKeys.DATA_CLIENT_FIELDGROUP_PHONENUMBERS + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then((securityAccess: SecurityAccessEnum) => {
                this.isPhoneNumberAccessDeny = securityAccess === SecurityAccessEnum.Deny;
            });
            this.securityChecker.checkSecurityKey(this.securityKeys.DATA_CLIENT_FIELD_IMAGE + this.securityParts.KEY_PART_CREATE).then((securityAccess: SecurityAccessEnum) => {
                this.isFileUploadAccessDeny = securityAccess === SecurityAccessEnum.Deny;
            });

            const messengerKeys: string[] = [
                this.securityKeys.INTEGRATION_TWOWAYSMS + this.securityParts.KEY_PART_READ,
                this.securityKeys.INTEGRATION_TEXTEL + this.securityParts.KEY_PART_READ
            ];
            this.securityChecker.checkAndCache(messengerKeys)
                .then((result: Model.SecurityItem[]) => {
                    let twoWaySecItem = result.find((item) => item.key === messengerKeys[0]);
                    let textelSecItem = result.find((item) => item.key === messengerKeys[1]);

                    if (twoWaySecItem.securityAccess !== SecurityAccessEnum.Hide) {
                        this.meevoMessengerSecurityKey = this.securityKeys.INTEGRATION_TWOWAYSMS;
                    } else {
                        this.meevoMessengerSecurityKey = this.securityKeys.INTEGRATION_TEXTEL;
                    }

                    this.isTextelOrTwoWaySmsEnabled = twoWaySecItem.securityAccess === SecurityAccessEnum.Grant || textelSecItem.securityAccess == Meevo.Model.SecurityAccessEnum.Grant;
                });
        }

        showCopyLogic() {
            if (!this.selectedSection) {
                return false;
            }

            var containsSection = _.contains([3, 4, 6, 7, 10], this.selectedSection.sectionId);
            return containsSection ? false : super.showCopyLogic();
        }

        get showDelete(): boolean {
            return this.showDeleteLogic() && !this.isApplicationModeCO();
        }

        showDeleteLogic() {
            if (!this.selectedSection) {
                return false;
            }

            var containsSection = _.contains([3, 4, 6, 7, 10], this.selectedSection.sectionId);
            return containsSection ? false : super.showDeleteLogic();
        }

        loadNotificationSetting(client?: Model.Client): any {
            // Resolve the opt-in number live from Twilio only when the label will actually render — i.e. toll-free
            // is supported and the client has a phone with a STOP issued. Callers that don't show the label (e.g.
            // the History tab) pass no client, so we skip the Twilio lookup.
            var fetchAssignedPhoneNumber = this.isTollFreeNumberSupported
                && !!client && !!client.phoneNumbers
                && client.phoneNumbers.some((p: any) => p.isStopSmsIssued);

            this.dataService.customMethodData('api/Client/NotificationSetting?fetchAssignedPhoneNumber=' + fetchAssignedPhoneNumber, 'GET', {}).then(
                (result: any) => {
                    this.notificationSetting = result.data;
                    if (this.notificationSetting) {
                        this.twilioPhoneNumber = this.notificationSetting.smsServiceFromPhoneNumber;
                        this.unstopSmsLabel = this.$translate.instant('LABEL_UNSTOP_SMS', { twilioPhoneNumber: this.twilioPhoneNumber });
                    }
                },
                (exception: any) => {
                    this.notificationSetting = null;
                });
        }

        navigateToMessenger({ id, firstName, lastName, isRestricted, meevoFile }, phoneNumber: {countryCode: string, number: string}): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.meevoMessenger,
                stateParams: { id,
                    firstName,
                    lastName,
                    primaryPhoneNumber: phoneNumber.number,
                    countryCode: phoneNumber.countryCode,
                    isRestricted,
                    isClient: true,
                    meevoFile,
                    classification: this.meevoMessengerSecurityKey === this.securityKeys.INTEGRATION_TEXTEL
                        ? 'TEXTEL' : 'SMS',
                }
            });
        }

        smsEnabled(): boolean {
            return this.notificationSetting && this.notificationSetting.isSmsEnabledCurrentLevel;
        }

        createDateFormat(): string {
            var temp = this.$locale.DATETIME_FORMATS.shortDate.trim();
            var concatenatedDateFormat: string = '';

            var dtFormatFirstChar: string = null;
            var dtFormatSecondChar: string = null;
            var dtFormatThirdChar: string = null;

            for (var i = 0; i < temp.length; i++) {
                if ('MDY'.indexOf(temp[i].toUpperCase()) >= 0) {
                    if (dtFormatFirstChar == null) {
                        dtFormatFirstChar = temp[i].toUpperCase();
                    } else if (dtFormatFirstChar != temp[i].toUpperCase() && dtFormatSecondChar == null) {
                        dtFormatSecondChar = temp[i].toUpperCase();
                    } else /*if (this.dtFormatFirstChar != temp[i] && this.dtFormatSecondChar != temp[i] && this.dtFormatThirdChar == null)*/ {
                        dtFormatThirdChar = temp[i].toUpperCase();
                    }
                } else if (dtFormatFirstChar != null) {
                    if (this.firstDelimiter == null) {
                        this.firstDelimiter = temp[i];
                    } else {
                        this.secondDelimiter = temp[i];
                    }
                }
            }

            this.dtMonthIndex = dtFormatFirstChar === 'M' ? 0 : dtFormatSecondChar === 'M' ? 1 : 2;
            this.dtDayIndex = dtFormatFirstChar === 'D' ? 0 : dtFormatSecondChar === 'D' ? 1 : 2;
            this.dtYearIndex = dtFormatFirstChar === 'Y' ? 0 : dtFormatSecondChar === 'Y' ? 1 : 2;

            concatenatedDateFormat += this.getConcatenatedDateFormatString(dtFormatFirstChar, this.firstDelimiter);
            concatenatedDateFormat += this.getConcatenatedDateFormatString(dtFormatSecondChar, this.secondDelimiter);
            concatenatedDateFormat += this.getConcatenatedDateFormatString(dtFormatThirdChar, '');
            return concatenatedDateFormat;
        }

        getConcatenatedDateFormatString(dateChar: string, delimiter: string): string {
            var soFarConcatenated = '';
            if (dateChar.toUpperCase() == 'Y') {
                soFarConcatenated += 'YYYY' + delimiter;
            } else if (dateChar.toUpperCase() == 'M') {
                soFarConcatenated += 'MM' + delimiter;
            } else if (dateChar.toUpperCase() == 'D') {
                soFarConcatenated += 'DD' + delimiter;
            }
            return soFarConcatenated;
        }

        emailEnabled(): boolean {
            return this.notificationSetting && this.notificationSetting.isEmailEnabledCurrentLevel;
        }

        smsEnabledAllLevels(): boolean {
            return this.notificationSetting && this.notificationSetting.isSmsEnabled;
        }

        initializeHeader(model: any): void {
            this.headerContent = model.lastName + ', ' + model.firstName + (model.hasLocalProfile ? '  [Local Activity]' : '');
            this.clientEmployeeLinkList = model.clientEmployeeLinkList;
            // TODO: Review whether this is the best place to add recent or if it is called too often.
            this.recentService.addRecent(model, Meevo.Components.Common.Constants.RECENT_KEY_CLIENT, true);
            this.updateLockAndRestriction(model);
        }

        updateLockAndRestriction(model: any): void {
            if (model.isLockedForEditing != null) {
                this.isClientLockedForEditing = model.isLockedForEditing;
            }
            if (model.isRestricted != null) {
                this.isClientRestricted = model.isRestricted;
            }

            this.showUnlockButton = (this.lockRestrictedClient && this.isClientLockedForEditing);
            this.showUnrestrictButton = (this.disableEditingOfRestrictedClient && (!this.lockRestrictedClient || !this.isClientLockedForEditing) && this.isClientRestricted);
        }

        /**
         * Creates a new client visit note with whatever shape it should have when first added by a sublist.
         */
        createNewClientVisitNote() {
            if (!this.isModelEditableEvenWhenRestricted()) {
                this.modalService.alert('MESSAGE_CANNOT_EDIT_RESTRICTED_CLIENT');
                return;
            }

            if (this.identityService.current().fullAccess || this.securityChecker.hasSecurity(this.securityKeys.DATA_CLIENT_TAB_VISITNOTES + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE)) {
                this.selectedSection["previousVisitNoteType"] = null;
                this.selectedSection["previousVisitNoteText"] = null;
                return this.dataService.getTemplate(this.baseEndpoint, this.itemId, 'visitnotes');
            }
        }

        setClientVisitNoteSortOptions(sort, selectedSortOption) {
            sort.sortBy = selectedSortOption.sortBy;
            sort.sortDirection = selectedSortOption.sortDirection;
        }

        /**
         * Creates a new client note with whatever shape it should have when first added by a sublist.
         */
        createNewClientNote() {
            if (!this.isModelEditableEvenWhenRestricted()) {
                this.modalService.alert('MESSAGE_CANNOT_EDIT_RESTRICTED_CLIENT');
                return;
            }

            if (this.identityService.current().fullAccess || this.securityChecker.hasSecurity(this.securityKeys.DATA_CLIENT_TAB_NOTES + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE)) {
                return this.dataService.getTemplate(this.baseEndpoint, this.itemId, 'notes');
            }
        }

        /**
         * Gets client note with extended note text.
         */
        getExtendedNote(item: any): any {
            let uri = `/${this.appSettings.API_ROOT}/${this.baseEndpoint}/${this.itemId}/notes/${item.id}/extended`;
            return this.dataService.customMethodData(uri, 'GET', null);
        }

        /**
         * Gets client note with extended note text.
         */
        getExtendedVisitNote(item: any): any {
            let uri = `/${this.appSettings.API_ROOT}/${this.baseEndpoint}/${this.itemId}/visitnotes/${item.id}/extended`;
            return this.dataService.customMethodData(uri, 'GET', null);
        }

        /**
         * Updates a client Package's Available For Use Value
         * @param clientPackage_TId
         * @param service_TId
         * @param availableForUse
         */
        updateClientPackage(id, isAvailableForUseWhenExpired, entityVersion): any {
            //this.securityKeys.DATA_CLIENT_
            var request = {
                'id': id,
                'isAvailableForUseWhenExpired': isAvailableForUseWhenExpired,
                'entityVersion': entityVersion
            };
            this.dataService.customMethodData(this.appSettings.API_ROOT + '/ClientPackage/' + id + '/AvailableForUseWhenExpired', 'POST', request)
                .then((response: any) => {

                });
        }

        createNewCreditCard() {
            if (!this.isModelEditableEvenWhenRestricted()) {
                this.modalService.alert('MESSAGE_CANNOT_EDIT_RESTRICTED_CLIENT');
                return this.$q.resolve(null);
            }

            let defer = this.$q.defer();
            if (this.identityService.current().fullAccess || this.securityChecker.hasSecurity(this.securityKeys.DATA_CLIENT_TAB_CREDITCARDS + Meevo.Components.Common.SecurityParts.KEY_PART_CREATE)) {
                this.dataService.getTemplate(this.baseEndpoint, this.itemId, 'creditcard').then(creditCard => {
                    let posStationId = this.$cookies.get('POSStation');
                    if (posStationId != null) {
                        this.dataService.getItem('PosHardware/device/' + posStationId + '?DeviceType=' + Meevo.Model.DeviceTypeEnum.PosStation)
                            .then((posdata: any) => {
                                if (posdata.terminalId) {
                                    creditCard.merchantTerminalId = posdata.terminalId;
                                    defer.resolve(creditCard);
                                } else if (posdata.drawerId) {
                                    this.dataService.getItem(`${this.appSettings.API_ENDPOINTS.drawer}/${posdata.drawerId}`).then((drawer: any) => {
                                        creditCard.posStationDrawer = drawer;
                                        creditCard.merchantTerminalId = drawer.creditCardTerminalId;
                                        defer.resolve(creditCard);
                                    });
                                } else {
                                    defer.resolve(creditCard);
                                }
                            });
                    } else {
                        this.dataService.getItem(this.appSettings.API_ENDPOINTS.session + '/DrawerPreferences').then((prefs: any) => {
                            if (prefs.lastUsedDrawerId) {
                                this.dataService.getItem(`${this.appSettings.API_ENDPOINTS.drawer}/${prefs.lastUsedDrawerId}`).then((drawer: any) => {
                                    creditCard.merchantTerminalId = drawer.creditCardTerminalId;
                                    defer.resolve(creditCard);
                                });
                            } else if (prefs.lastUsedCreditCardTerminalId) {
                                creditCard.merchantTerminalId = prefs.lastUsedCreditCardTerminalId;
                                defer.resolve(creditCard);
                            } else {
                                defer.resolve(creditCard);
                            }
                        });
                    }

                });
            }
            return defer.promise;
        }

        /**
         * Opens a modal for appointment audit details from the Client > History section.
         * This is triggered by the sublist used to display the history items.
         * @param appointmentId
         */
        viewAuditDetail(appointmentId: Guid) {

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/AppointmentBook/views/AppointmentAuditLog.html',
                controller: 'AppointmentAuditLogController',
                controllerAs: undefined,
                bindToController: true,
                locals: {
                    appointmentId: appointmentId,
                    appointmentServiceScheduleId: undefined,
                    appointmentRequestId: undefined
                }
            }

            this.modalService.showCustom(options);
        }

        viewClientHistoryNoteModal(item) {
            var dataForModal = [];
            if (item.clientTransactionHistoryNotes) {
                dataForModal = item.clientTransactionHistoryNotes;
            } else {
                dataForModal.push({
                    noteText: item.noteText,
                    saleNoteTypeEnum: item.saleNoteTypeEnum
                });
            }

            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: 'app/plugins/client/sectionViews/clientHistoryNotes.html',
                controller: 'meevo.plugins.client.ClientHistoryNoteController',
                controllerAs: 'vm',
                bindToController: true,
                clickOutsideToClose: false,
                locals: {
                    notes: dataForModal
                }
            }

            this.modalService.showCustom(options);
        }

        isGiftCardType(saleLineType: Meevo.Model.SalesTypeEnum): boolean {
            return saleLineType === Meevo.Model.SalesTypeEnum.GiftCard || saleLineType === Meevo.Model.SalesTypeEnum.ReloadGiftCard;
        }
        isBulkGiftCardType(saleLineType: Meevo.Model.SalesTypeEnum): boolean {
            return saleLineType === Meevo.Model.SalesTypeEnum.BulkGiftCard;
        }
        openGcLookupModal(id: string) {   //gotoItemLink
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: 'giftCardBalance',
                stateParams: {
                    giftCardId: id,
                    callbackState: 'client',
                }
            });
        }

        viewGiftCardHistoryDetails(item: any): void {
            item.expandedDetails = item.expandedDetails ? !item.expandedDetails : true;

            if (item.expandedDetails) {
                var request = {
                    criteria: {
                        isActiveOnly: true
                    }
                };
                this.dataService.customMethodData(this.appSettings.API_ROOT + '/' + this.baseEndpoint + '/' + item.clientId + '/GiftCard/' + item.id, 'POST', request)
                    .then((response: any) => {
                        if (!response.data.length) response.data = [response.data];

                        for (var i = 0; i < response.data.length; i++) {
                            response.data[i]['displayDate'] = moment(response.data[i].transactionDateTime).format('L LTS');
                        }
                        item.payments = response.data;
                    });
            }
        }


        viewTransactionHistoryDetails(item: any, discount: boolean): void {
            item.expandedDetails = item.expandedDetails ? !item.expandedDetails : true;

            if (item.expandedDetails && !item.detail && !discount) {
                this.getTransactionDetail(item);
            }
        }

        getTransactionDetail(item) {
            this.dataService.customMethodData('api/sale/' + item.transactionNumber, 'POST',
                {
                    id: item.transactionNumber,
                    locationId: item.saleLocationId ? item.saleLocationId : item.locationId,
                    locale: this.appSettings.APP_COUNTRYID
                }).then((response) => {
                item.detail = response.data;

                // TODO: this always returns null because item object is now a sale
                let saleLine = _.find(item.detail.saleLines, (sl: any) => {
                    return sl.id == item.saleLineId;
                });

                if (saleLine && saleLine.discountLines && saleLine.discountLines.length) {
                    if (_.findWhere(saleLine.discountLines, { saleLineDiscountType: Model.SaleLineDiscountTypeEnum.CancellationFee })) {
                        item.cxl = true;
                    }
                    if (_.findWhere(saleLine.discountLines, { saleLineDiscountType: Model.SaleLineDiscountTypeEnum.NoShowFee })) {
                        item.ns = true;
                    }
                }
            });
        }

        openTransactionEditor(transactionNumber: string, locationId: number): void {
            if (!transactionNumber || transactionNumber === 'N/A') return;

            //if (!isLocalTransaction) {
            if (locationId !== this.identityService.locationId) {
                this.modalService.alert('MESSAGE_TRANSACTION_AT_ANOTHER_LOCATION', Components.Modal.ModalTranslationModes.Translate);
                return;
            }

            // Build params for loading transaction in editor
            let stateParams = {
                transactionId: transactionNumber,
                includeActive: true,
                includeCompleted: true,
                includeOnHold: false,
                includeRefunded: true,
                includeVoided: true
            };
            this.$rootScope.$broadcast('gotoState', {
                stateName: this.appSettings.ROUTE_NAMES.transactionEditor,
                stateParams: stateParams,
                securityKey: Meevo.Components.Common.SecurityKeys.REGISTER_TRANSACTIONEDITOR + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
            });
        }

        getDefaultCriteria() {
            let cri: any = { isGlobal: false };
            if (this.selectedSection instanceof HistorySection && !!this.selectedSection.historyFilter) {
                cri.filter = this.selectedSection.historyFilter;
            } else {
                cri.filter = Meevo.Plugins.Client.ClientAppointmentHistoryFilterType.All.toString();
            }
            return cri;
        }

        getCreditCardDefaultCriteria() {
            return {
                isApproved: null
            };
        }

        getFieldSecurityKeys(): any {
            return this.securityKeys;
        }

        setFocusOnField(field: any, actionState: any) {
            this.mode = actionState;
            if (actionState == Meevo.Model.MaintenanceFormState.Editing) {
                this.mainSection.missingField = field;
                this.mainSection.beforeSetFocusOnField();
            }
        }

        setFilter(filter: number) {
            this.historySection.historyFilter = filter;
        }

        setLoadingInProgress(isLoading: boolean) {
            this.loadingInProgress = isLoading;
        }

        clientTempSave: any = undefined;
        clientEmployeeLinkList: any = undefined;

        postAdd(model: any): void {
            this.clientTempSave = model.meevoFile;
            model.isStorageUpdated = false;

            if (this.selectedSection.sectionId == this.sections[0].sectionId) {
                let main = <MainSection>this.selectedSection;
                main.tempNotification = [];
            }
            super.postAdd(model);
        }

        postUpdate(model: any): void {
            model.isStorageUpdated = false;

            if (this.mainSection && this.selectedSection.sectionId == this.mainSection.sectionId) {
                this.mainSection.tempNotification = [];
            }
            else if (this.notificationsSection && this.selectedSection.sectionId === this.notificationsSection.sectionId) {
                if (this.notificationsSection.doNotConfirmChanged) {
                    this.dataService.patch(`/Client/${model.id}/AppointmentSchedule`, {
                        Model: {
                            DoNotConfirm: model.doNotConfirm
                        }
                    });

                    this.dataService.patch(`/Client/${model.id}/Appointment`, {
                        Model: {
                            DoNotConfirm: model.doNotConfirm
                        }
                    });
                }
            }
            super.postUpdate(model);
        }

        postCancel(): void {
            let model = this.castModel<Model.Client>();
            if (model && model.id) {
                this.itemId = new Guid(model.id);
            }
            if (this.clientTempSave) {
                model.meevoFile = this.clientTempSave;
                model.isStorageUpdated = false;
            }
            if (model && model.fileGuid) {
                let deleteJson = {
                    FileGuid: model.fileGuid,
                    LocationId: model.locationId,
                    ResourceType: <Meevo.Model.FileTypes>Meevo.Model.FileTypes['ClientImage']
                }
                this.dataService.deleteFile(model.meevoFile.config.endPoint, deleteJson);
            }
            this.mainSection.invalidFormAttemptedSave = false;
            this.resetDuplicateFlags();
            
            super.postCancel();
        }

        postCopy(): void {
            let model = this.castModel<Model.Client>();
            console.log('post copy!: ', model);
            model.meevoFile = undefined;
            model.fileGuid = undefined;
            model.isStorageUpdated = false;
            // need to clear the itemId to remove the Client Indicators
            this.itemId = null;
            console.log('post copy!: ', model);
            super.postCopy();
        }

        postSave(model: any): void {
            super.postSave(model);
            // need to update the itemId to null then back to refresh the 
            // Client Indicators in case something changed like Minor or Restricted
            var lastItemId = this.itemId;
            this.itemId = null;
            setTimeout(() => { this.itemId = lastItemId; }, 0);
            this.updateLockAndRestriction(model);
            this.resetDuplicateFlags();

        }

        invalidFieldCheck() {
            let emailAddressNotUnique: boolean = angular.element(document.getElementsByName("emailAddress")).hasClass("ng-invalid-unique");

            this.mainSection.invalidFormAttemptedSave = true;

            if (emailAddressNotUnique) {
                this.modalService.alert("ERROR_DUPLICATE_PLEASE_USE_DIFF_EMAIL", 0, true);
                return true;
            }
            
            return false;
        }

        private resetDuplicateFlags(): void {
            if (this.mainSection) {
                this.mainSection.allowDuplicateClientProfile = false;
            }
            this.phoneNumberWarningPromise = null;
            this.phoneNumberWarningInProgress = false;
        }

        public phoneNumberWarningPromise: angular.IPromise<boolean> = null;
        public phoneNumberWarningInProgress: boolean = false;
        save(): angular.IPromise<any> {
            let proceedWithSave = (): angular.IPromise<any> => {
                let model = this.castModel<Model.Client>();
            
                /** Block save when the birthday dropdown date is invalid (e.g. Feb 29 on a non-leap year)
                or is a future date. **/
                if (this.mainSection && this.selectedSection.sectionId === this.mainSection.sectionId 
                    && !this.mainSection.showBirthdayDatePicker && (this.mainSection.birthdayDateIsInvalid || this.mainSection.birthdayIsFutureDate)) {
                    this.modalService.alert('MESSAGE_COMPLETE_ALL_FIELDS_THAT_REQUIRE_ATTENTION', 0, true);
                    return this.$q.resolve(null);
                }

                // check if a phone number has less than 4 digits
                if (model.phoneNumbers
                    && model.phoneNumbers.length > 0
                    && model.phoneNumbers.some(p => p.countryCode === "1" && p.number && p.number.length <= 4 && p.number.length > 0)) {
                    this.busyService.stop();
                    this.modalService.alert('MESSAGE_CLIENT_PHONE_INVALID');
                    return this.$q.reject('PHONE_INVALID');
                }
                if (this.mainSection && this.selectedSection.sectionId == this.mainSection.sectionId) {
                    return this.mainSection.checkForLocationDuplicatesByPhone()
                        .then((hasNoDupes: boolean) => {
                            if (hasNoDupes || this.mainSection.allowDuplicateClientProfile) {
                                return super.save();
                            }
                            return this.$q.reject('DUPLICATE_FOUND');
                        });
                }
                return super.save();
            };

            if (this.phoneNumberWarningPromise) {
                let pending = this.phoneNumberWarningPromise;
                this.phoneNumberWarningPromise = null;  // consumed here
                return pending.then((canProceed: boolean) => {
                    if (canProceed !== false) {
                        // User already acknowledged the duplicate phone warning,
                        // skip the redundant check in checkForLocationDuplicatesByPhone
                        if (this.mainSection) {
                            this.mainSection.allowDuplicateClientProfile = true;
                        }
                        return proceedWithSave();
                    }
                    return this.$q.reject('WARNING_ABORTED');
                });
            }

            return proceedWithSave();
        }

        updateAfterUnsuccessSave(): void {
            if (this.selectedSection.sectionId == this.sections[0].sectionId) {
                let main = <MainSection>this.selectedSection;
                main.clearGuardianTempUnsuccessfulSave();
            }

            if (this.selectedSection.sectionId == this.sections[1].sectionId) {
                let notification = <NotificationsSection>this.selectedSection;
                notification.clearGuardianTempUnsuccessfulSave();
            }
        }


        add(preventUsageTracking: boolean = false): void {
            this.isClientLockedForEditing = false;
            this.isClientRestricted = false;
            this.itemId = null;
            this.resetDuplicateFlags();
            super.add(preventUsageTracking);
        }

        edit(isUndeleting: boolean = false): void {
            if (!this.isModelEditableEvenWhenRestricted()) {
                this.modalService.alert('MESSAGE_CANNOT_EDIT_RESTRICTED_CLIENT');
                return;
            }
            this.resetDuplicateFlags();
            super.edit(isUndeleting);
        }

        delete(): void {
            if (!this.isModelEditableEvenWhenRestricted()) {
                this.modalService.alert('MESSAGE_CANNOT_EDIT_RESTRICTED_CLIENT');
                return;
            }
            this.selectedSection.model.suppressWarnings = false;

            let vm = this;
            // Do not allow CO-owned items to be deleted in a location
            if (vm.isCoItemInLocation || vm.isLocationImpersonating) {
                vm.modalService.alert("MESSAGE_CANNOT_DELETE_CO_ITEM", Components.Modal.ModalTranslationModes.Translate);
                return;
            }
            if (this.canDelete) {

                this.modalService.warning(this.deleteConfirmationMessageKey, 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then(() => {
                        vm.loadingInProgress = true;
                        // Patch model object state to deleted
                        vm.dataService.objectStatePatch(vm.baseEndpoint,
                            vm.itemId,
                            vm.selectedSection.model.entityVersion,
                            <number>Model.ObjectStateEnum.Deleted,
                            vm.asLocationId,
                            this.selectedSection.sectionEndpoint,
                            false)
                            .then((data) => {
                                if (data.isWarning) {
                                    this.handleClientDeleteWarnings(data.responseStatus.errors);
                                } else {

                                    if (data) {
                                        vm.selectedSection.model = data;
                                        vm.selectedSection.sectionModelRetrieved();
                                        vm.loggingService.trace(`Delete saved.`);
                                    }
                                    this.postDelete();
                                }
                            })
                            .finally(() => {
                                vm.loadingInProgress = false;
                            });
                    });
            } else {
                this.modalService.alert("ERROR_HTTP_403");
            }

        }

        copy(): void {
            if (!this.isModelEditableEvenWhenRestricted()) {
                this.modalService.alert('MESSAGE_CANNOT_EDIT_RESTRICTED_CLIENT');
                return;
            }
            this.resetDuplicateFlags();
            super.copy();
        }

        cleanup(): void {
            this._intakeFormWatcher();
            this.itemId = null;
        }


        handleClientDeleteConfirm(warnings: any[]): ng.IPromise<boolean> {
            //let messageHeading = 'This user is currently receiving notifications for:';
            //let message = messageHeading;
            let message = this.$translate.instant('MESSAGE_CLIENT_CURRENT_NOTIFY'); 
            let messageDetails: string = '<ul style="margin:0">';
            for (let warning of warnings) {
                messageDetails += "<li>" + warning.message + "</li>";
            }
            messageDetails += '</ul>';
            message += messageDetails;
            //TODO: Translate
            //message += " Once they are deleted the client will go back to receiving their own notifications. Are you sure you want to continue?";
            message += this.$translate.instant('MESSAGE_CLIENT_CURRENT_NOTIFY_POST'); 
            return this.modalService.confirm(message, Components.Modal.ModalTranslationModes.DoNotTranslate);
        }

        handleClientDeleteWarnings(warnings: any[]): ng.IPromise<any> {
            return this.handleClientDeleteConfirm(warnings)
                .then((response: boolean) => {
                    //this.saveInProgress = false;
                    if (response) {
                        this.selectedSection.model.suppressWarnings = true;
                        return this.postDeleteConfirmation();
                    }
                    return response;
                })
                .finally(() => {
                    this.loadingInProgress = false;
                    //this.saveInProgress = false;
                });
        }
        
        postDeleteConfirmation(): void {
            let vm = this;
            // Do not allow CO-owned items to be deleted in a location
            if (vm.isCoItemInLocation || vm.isLocationImpersonating) {
                vm.modalService.alert("MESSAGE_CANNOT_DELETE_CO_ITEM", Components.Modal.ModalTranslationModes.Translate);
                return;
            }
            if (this.canDelete) {
                vm.loadingInProgress = true;
                // Patch model object state to deleted
                vm.dataService.objectStatePatch(vm.baseEndpoint,
                    vm.itemId,
                    vm.selectedSection.model.entityVersion,
                    <number>Model.ObjectStateEnum.Deleted,
                    vm.asLocationId,
                    this.selectedSection.sectionEndpoint,
                    true)
                    .then((data) => {
                        if (data.isWarning) {
                            this.handleClientDeleteWarnings(data.responseStatus.errors);
                        } else {

                            if (data) {
                                vm.selectedSection.model = data;
                                vm.selectedSection.sectionModelRetrieved();
                                vm.loggingService.trace(`Delete saved.`);
                            }
                            this.postDelete();
                        }
                    })
                    .finally(() => {
                        vm.loadingInProgress = false;
                    });
            } else {
                this.modalService.alert("ERROR_HTTP_403");
            }
        }
        
 
        unlock(): ng.IPromise<any> {
            var client = this.castModel<Model.Client>();

            var msg: string = this.$translate.instant('MESSAGE_CONFIRM_UNLOCK', { clientDisplayName: client.displayName });

            return this.modalService.warning(msg, ModalTranslationModes.DoNotTranslate, false, {
                showCancelButton: true,
                okButtonContentKey: 'LABEL_YES',
                cancelButtonContentKey: 'LABEL_NO',
                cancelButtonHotKey: 'MODAL_NO_BUTTON',
                okButtonHotKey: 'MODAL_YES_BUTTON'
            }).then(_ => {
                this.busyService.start();

                return this.dataService
                    .customMethodData(`api/Client/${client.id}/Unlock`, 'POST', {
                        'id': client.id,
                        'entityVersion': client.entityVersion
                    })
                    .then(response => {
                        if (response.data) {
                            this.updateLockAndRestriction(response.data);
                            this.selectedSection.model = response.data;
                            this.selectedSection.sectionModelRetrieved();
                            this.selectedSection.activate();
                        }
                    })
                    .finally(() => {
                        this.busyService.stop();
                    });
            });
        }

        unrestrict(): ng.IPromise<any> {
            var client = this.castModel<Model.Client>();

            var msg: string = this.$translate.instant('MESSAGE_CONFIRM_UNRESTRICT', { clientDisplayName: client.displayName });

            return this.modalService.warning(msg, ModalTranslationModes.DoNotTranslate, false, {
                showCancelButton: true,
                okButtonContentKey: 'LABEL_YES',
                cancelButtonContentKey: 'LABEL_NO',
                cancelButtonHotKey: 'MODAL_NO_BUTTON',
                okButtonHotKey: 'MODAL_YES_BUTTON'
            }).then(_ => {
                this.busyService.start();

                return this.dataService
                    .customMethodData(`api/Client/${client.id}/Unrestrict`, 'POST', {
                        'id': client.id,
                        'entityVersion': client.entityVersion
                    })
                    .then(response => {
                        if (response.data) {
                            this.updateLockAndRestriction(response.data);
                            this.selectedSection.model = response.data;
                            this.selectedSection.sectionModelRetrieved();
                            this.selectedSection.activate();
                            this.$scope.$broadcast(Meevo.Components.Common.Messages.RESET_INDICATORS);
                        }
                    })
                    .finally(() => {
                        this.busyService.stop();
                    });
            });
        }

        tryViewModal() {
            let index = 0;
            let model = this.castModel<Model.Client>();
            this.dataService.trackUsage(Meevo.Model.NounEnum.ClientImageUpdate, Meevo.Model.VerbEnum.Updated, null, this.itemId);
            if (!this.isAdding && !this.isEditing) {
                if (model.meevoFile) {
                    if (model.meevoFile.files) {
                        model.meevoFile.files.forEach((curVal, curIndex, array) => {
                            if (curVal.key === 'Source') {
                                index = curIndex;
                            }
                        });
                    }

                    let srcImageData = model.meevoFile.files[index]
                    let options = {
                        templateUrl: 'app/plugins/client/imageViewerModal.template.html',
                        controller: 'meevo.plugins.client.ImageViewerController',
                        controllerAs: 'vm',
                        preserveScope: true,
                        locals: {
                            srcImageUri: srcImageData.fileUrl,
                            context: this
                        },
                        bindToController: true
                    }

                    this.modalService.showCustom(options);
                }
            }
        }

        /**
         * Refund receipt
         */
        refundReceipt(item): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.register,
                stateParams: {
                    action: Meevo.Components.Common.Messages.REGISTER_REFUND_RECEIPT,
                    transactionNumber: item.transactionNumber,
                }
            });
        }

        goToPoints(): void {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.clientPoint,
                stateParams: {
                    callback: null,
                    callbackState: null,
                    targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                    actionState: Meevo.Model.MaintenanceFormState.Readonly,
                    id: this.selectedSection.model != null ? this.selectedSection.model.id : this.selectedSection.getParentItemId()
                }
            });
        }

        checkForItemDetail(item) {
            if (!item.detail) {
                this.getTransactionDetail(item);
            }
        }

        hasPurchasedItems(item) {
            return (item.detail && item.detail.hasPurchasedItems != undefined) ? item.detail.hasPurchasedItems : false;
        }

        fileTypesEnum = Meevo.Model.FileTypes;

        teacherModuleActivated() {
            return this
                .securityChecker
                .hasSecurityDenyOrGrant(this.securityKeys.DATA_TEACHER + Meevo.Components.Common.SecurityParts.KEY_PART_READ);
        }

        isEmailEnabledAtHigherLevel(communicationType: any): boolean {
            var isEnabled = true;
            if (this.notificationSetting) {
                var notification = this.notificationSetting.communicationTypeNotifications.filter(n => n.communicationTypeUser === Meevo.Model.CommunicationTypeUserEnum.Client && n.communicationType === communicationType)[0];
                if (notification) {
                    isEnabled = notification.isEmailEnabled && notification.isEmailEnabledCurrentLevel;
                }
            }
            return isEnabled;
        }

        isSMSEnabledAtHigherLevel(communicationType: any): boolean {
            var isEnabled = true;
            if (this.notificationSetting) {
                var notification = this.notificationSetting.communicationTypeNotifications.filter(n => n.communicationTypeUser === Meevo.Model.CommunicationTypeUserEnum.Client && n.communicationType === communicationType)[0];
                if (notification) {
                    isEnabled = notification.isSMSEnabled && notification.isSmsEnabledCurrentLevel;
                }
            }
            return isEnabled;
        }

        showRevertIndicator(clientNotification: any, communicationMethod: Meevo.Model.CommunicationMethodEnum): boolean {
            var canShow = false;
            if (clientNotification) {
                if (communicationMethod === Meevo.Model.CommunicationMethodEnum.Email) {
                    if (clientNotification.isEmailEnabled !== clientNotification.isEmailEnabledDefault)
                        canShow = true;
                } else if (communicationMethod === Meevo.Model.CommunicationMethodEnum.SMS) {
                    if (clientNotification.isSMSEnabled !== clientNotification.isSMSEnabledDefault)
                        canShow = true;
                }
            }
            return canShow;
        }

        revertToParent(clientNotification: any, communicationMethod: Meevo.Model.CommunicationMethodEnum): void {
            if (clientNotification) {
                if (communicationMethod === Meevo.Model.CommunicationMethodEnum.Email) {
                    if (clientNotification.isEmailEnabled !== clientNotification.isEmailEnabledDefault)
                        clientNotification.isEmailEnabled = clientNotification.isEmailEnabledDefault;
                } else if (communicationMethod === Meevo.Model.CommunicationMethodEnum.SMS) {
                    if (clientNotification.isSMSEnabled !== clientNotification.isSMSEnabledDefault)
                        clientNotification.isSMSEnabled = clientNotification.isSMSEnabledDefault;
                }
            }
        }

        goToIntakeForm(clientId: string): void {
            if (!this.isModelEditableEvenWhenRestricted()) {
                this.modalService.alert('MESSAGE_CANNOT_EDIT_RESTRICTED_CLIENT');
                return;
            }

            // Check if form exists
            this.clientIntakeFormService
                .getForm(this.identityService.businessTypeId, this.$scope)
                .then(() => this.openIntakeForm(clientId));
        }


        loadSendDaysBeforeList(communicationType: Model.CommunicationTypeEnum, sendDaysBefore: any): void {
            if (communicationType === Model.CommunicationTypeEnum.AppointmentConfirmation) {
                this.apptConfirmationSendDaysBeforeList = [1, 2, 3, 4, 5, 6, 7];

                // Adding sendDaysBefore value for new or converted (having no client notification settings of their own) clients, if other than range 1-7.
                if (!this.apptConfirmationSendDaysBeforeList.some(x => x === sendDaysBefore)) {
                    this.apptConfirmationSendDaysBeforeList.push(sendDaysBefore);
                }

                if (!this.isAdding) {
                    // Adding sendDaysBeforeDefault (Higher Level Setting) for existing clients, if other than range 1-7.
                    // Higher Level could have sendDaysBeforeDefault other than range 1-7, which should be a valid selection for existing clients.
                    this.getHigherLevelSendDaysBeforeDefault(communicationType, this.apptConfirmationSendDaysBeforeList);
                }
                this.apptConfirmationSendDaysBeforeList.sort((n1, n2) => n1 - n2);
            } else if (communicationType === Model.CommunicationTypeEnum.AppointmentReminderDaysBefore) {
                this.apptReminderSendDaysBeforeList = [1, 2, 3, 4, 5, 6, 7];

                // Adding sendDaysBefore value for new or converted (having no client notification settings of their own) clients, if other than range 1-7.
                if (!this.apptReminderSendDaysBeforeList.some(x => x === sendDaysBefore)) {
                    this.apptReminderSendDaysBeforeList.push(sendDaysBefore);
                }

                if (!this.isAdding) {
                    // Adding sendDaysBeforeDefault (Higher Level Setting) for existing clients, if other than range 1-7.
                    // Higher Level could have sendDaysBeforeDefault other than range 1-7, which should be a valid selection for existing clients.
                    this.getHigherLevelSendDaysBeforeDefault(communicationType, this.apptReminderSendDaysBeforeList);
                }
                this.apptReminderSendDaysBeforeList.sort((n1, n2) => n1 - n2);
            }
        }

        getHigherLevelSendDaysBeforeDefault(communicationType: Model.CommunicationTypeEnum, sendDaysBeforeList: any): void {
            if (this.notificationSetting) {
                var notification = this.notificationSetting.communicationTypeNotifications.filter(n => n.communicationTypeUser === Meevo.Model.CommunicationTypeUserEnum.Client &&
                    n.communicationType === communicationType)[0];
                if (notification) {
                    if (!sendDaysBeforeList.some(x => x === notification.sendDaysBeforeDefault)) {
                        sendDaysBeforeList.push(notification.sendDaysBeforeDefault);
                    }
                }
            }
        }

        isModelEditableEvenWhenRestricted(): boolean {
            let model = this.castModel<Model.Client>();
            return !(this.disableEditingOfRestrictedClient && (this.isClientRestricted || model && model.isRestricted));
        }

        private openIntakeForm(clientId: string) {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.clientIntake,
                stateParams: {
                    clientId: clientId,
                    fromState: 'client'
                },
            });
        }

        sendToClientFind(clientId, any): void {
            if (clientId === null) {
                return;
            }

            this.sideContextMenu('Search').open().then((o) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.OPEN_SEARCH_MENU_COMPLETE, {
                    id: clientId,
                    landingTab: Meevo.Model.NounEnum.ClientFindSendTextMsgTab
                });
            });
        }

        goToDuplicateClientProfile(existingClientId) {
            let stateParams = {
                id: existingClientId,
                actionState: Meevo.Model.MaintenanceFormState.Readonly,
                targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                callback: null,
                callbackController: null,
                callbackState: null,
                callbackData: null,
                typeaheadMode: null,
                redirectFromDupe: true
            };

            if (this.contextParams && this.contextParams.params) {
                if (this.contextParams.params.callback != null) {
                    stateParams.callback = this.contextParams.params.callback;
                }
                if (this.contextParams.params.callbackController != null) {
                    stateParams.callbackController = this.contextParams.params.callbackController;
                }
                if (this.contextParams.params.callbackState != null) {
                    stateParams.callbackState = this.contextParams.params.callbackState;
                }
                if (this.contextParams.params.callbackData != null) {
                    stateParams.callbackData = this.contextParams.params.callbackData;
                }
                if (this.contextParams.params.typeaheadMode != null) {
                    stateParams.typeaheadMode = this.contextParams.params.typeaheadMode;
                }
                if (this.contextParams.params.targetState != null) {
                    stateParams.targetState = this.contextParams.params.targetState;
                }
            }

            this.$rootScope.$broadcast("gotoState", {
                stateName: this.appSettings.ROUTE_NAMES.client,
                stateParams: stateParams
            });
        }

        showClientIndicators() : boolean {
            return (this.itemId !== null && this.selectedSection && this.selectedSection.model !== null && this.selectedSection.isPrimarySection) || (this.itemId && this.selectedSection && !this.selectedSection.model && !this.selectedSection.isPrimarySection);
        }

        toggleExpander() {
            this.isExpanded = !this.isExpanded;
        }

    }
}
